import type { PodcastGenre } from '../models/podcast-genres.js';
import type { User } from '../models/user.model.js';
import type { FuuzeQueryKey } from './shared.js';

export const userQueryKeys = {
  signIn: ['userSignIn', { type: 'user' }] as FuuzeQueryKey,
  checkPseudoAvailability: (pseudo: string) =>
    ['userCheckPseudoAvailability', { type: 'noType' }, pseudo] as FuuzeQueryKey,
};

export const cloudflareQueryKeys = {
  verifyTurnstileToken: (token?: string) => ['verifyTurnstileToken', { type: 'noType' }, token] as FuuzeQueryKey,
};

// <!> new Query keys rework to migrate to

type QueryKeys = {
  user: {
    listLibraryAlreadyStartedEpisodes: (user?: User) => FuuzeQueryKey;
    listLibraryNonStartedEpisodes: (user?: User) => FuuzeQueryKey;
  };
  podcast: {
    listTopPodcasts: (params?: { genre?: PodcastGenre; limit?: number }) => FuuzeQueryKey;
  };
};

export const queryKeys = {
  user: {
    listLibraryAlreadyStartedEpisodes: user => [
      'listLibraryAlreadyStartedEpisodes',
      { type: 'podcastEpisode' },
      user?.subscribedChannels,
    ],
    listLibraryNonStartedEpisodes: user => [
      'listLibraryNonStartedEpisodes',
      { type: 'podcastEpisode' },
      user?.subscribedChannels,
    ],
  },
  podcast: {
    listTopPodcasts: params => ['listTopCharts', { type: 'podcastEpisode' }, params],
  },
} satisfies QueryKeys;
